import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es';
import {LOCALE_ID, Provider} from '@angular/core';
import {clearTranslations, loadTranslations} from '@angular/localize';

registerLocaleData(localeEs);

export const LANGUAGES = ['es', 'en'] as const;
export type Language = typeof LANGUAGES[number];
export const LANGUAGE_STORAGE_KEY = 'blocklabs.language';

let bootstrapLanguage: Language = 'es';

export function savedLanguage(): Language {
    const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return LANGUAGES.find(language => language === saved) ?? 'es';
}

export function provideAppLocale(): Provider {
    return {provide: LOCALE_ID, useFactory: () => bootstrapLanguage};
}

/** Spanish is the source; only English needs a translation catalog. */
export async function initializeTranslations(): Promise<Language> {
    clearTranslations();
    bootstrapLanguage = 'es';
    document.documentElement.lang = 'es';
    const url = document.querySelector<HTMLMetaElement>('meta[name="app-translations"]')?.content.trim();
    if (savedLanguage() !== 'en' || !url) return bootstrapLanguage;

    try {
        const response = await fetch(url, {signal: AbortSignal.timeout(5000)});
        const catalog: Record<string, {source: string; languages: {en?: string}}> | undefined = response.ok ? await response.json() : undefined;
        if (catalog) {
            const translations: Record<string, string> = {};
            for (const [id, message] of Object.entries(catalog)) {
                if (message.languages.en?.trim()) translations[id] = message.languages.en;
            }
            loadTranslations(translations);
            bootstrapLanguage = 'en';
            document.documentElement.lang = 'en';
        }
    } catch {
        clearTranslations();
        // Keep Spanish source usable offline; the saved English choice retries next bootstrap.
    }
    return bootstrapLanguage;
}
